module.exports = __webpack_public_path__ + "img/yinlian.f0a722ac.png";